<template>
  <div class="firrre">
    <div class="mask" v-loading="loding" v-show="loding"></div>
    <div class="documentList fire">
      <div v-show="showLxr">
        <div v-loading="upLoding" class="documentContent">
          <div class="inner">
            <div class="sponsorWarp">
              <div class="dh">
                <span class="cc">首页</span><i class="cc">/</i><span>发起签署</span>
              </div>
              <div class="sponsorContent">
                <div class="title">发起签署</div>
                <div class="sponsorInner" style="padding-bottom: 0">
                  <div class="innerS b8" style="overflow: inherit;">
                    <div class="innerTitle">上传文件</div>
                    <div class="upload fireEl">
                      <el-upload
                        class="avatar-uploader"
                        action="http://www.absign.cn:8080/api/common/files/uploadPrivae"
                        :show-file-list="false"
                        accept="application/pdf"
                        :headers="{'x-access-token':gUserInfo.token}"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload">
                        <div class="uploadInner">
                          <span class="removeUp" @click.stop="removeUp" v-if="pdfName!=''"></span>
                          <img src="../../assets/images/icon_docunment.png" alt="" v-if="pdfName==''">
                          <pdfMain :pdfUrl="fileurl" :mainPage="1"
                                   v-if="pdfName!='' &&isReload && fileurl!=''"></pdfMain>
                          <p class="txt">{{pdfName == '' ? '注：本平台可上传80M以下文档' : filename}}</p>
                        </div>
                        <div class="upBtn">{{pdfName == '' ? '上传文档' : '重新上传'}}</div>
                      </el-upload>
                    </div>
                  </div>
                  <div class="innerS noh" v-if="pdfName!=''">
                    <div class="innerTitle" style="line-height: normal">文档名称</div>
                    <el-input v-model="contractName" style="width: 340px;margin-top: 11px;"
                              placeholder="修改文档名称"></el-input>
                  </div>
                </div>
                <div class="sponsorInner">
                  <div class="innerS">
                    <div style="overflow: hidden">
                      <div class="innerTitle">选择签署方</div>
                      <ul class="userList">
                        <li v-for="(user,index) in choseList">
                          <span class="topname">{{type[index].name}}</span>
                          <el-select v-model="user.userType" placeholder="请选择">
                            <el-option
                              v-for="item in options"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                          </el-select>
                          <div class="inputWarp">
                            <i style="color:red">*</i>
                            <input type="number" class="inputs" placeholder="手机号码" v-model="user.phone">
                          </div>
                          <div class="inputWarp">
                            <i style="color:red">*</i>
                            <input type="text" class="inputs" placeholder="电子邮箱" v-model="user.email">
                          </div>
                          <div class="inputWarp">
                            <i style="color:red">*</i>
                            <input type="text" class="inputs" :placeholder="(user.userType==0)?'姓名':'企业名称'"
                                   v-model="user.companyName">
                          </div>
                          <div class="inputWarp">
                            <i style="color:red">*</i>
                            <input type="text" class="inputs" :placeholder="(user.userType==0)?'身份证号码':'统一社会信用代码'"
                                   v-model="user.card">
                          </div>
                          <span class="choseBtn" @click="nowId = index;showChoseUser = true"></span>
                          <span class="closeBtn" @click="removeLxr(index)"></span>
                        </li>
                      </ul>
                    </div>
                    <div class="addBtn" @click="addLxr" v-if="choseList.length<6">+</div>
                  </div>
                </div>
                <div class="t-btns">
                  <el-button class="button" type="warning" style="background: #3054c0;border: none" @click="next">确定</el-button>
                  <el-button class="button" @click="goSomgPage('/lindex')">返回</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="choseUser" v-if="showChoseUser">
          <div class="choseInner">
            <p class="title">选择联系人 <span class="close" @click="showChoseUser= false"></span></p>
            <div class="content">
              <div class="top">
                <span class="name">快速检索：</span>
                <el-autocomplete
                  class="inline-input"
                  v-model="state1"
                  :fetch-suggestions="querySearch"
                  placeholder="请输入内容"
                  @select="handleSelect"
                ></el-autocomplete>
              </div>
              <div class="scollContent">
                <el-table
                  max-height="300"
                  ref="singleTable"
                  :data="restaurants"
                  style="width: 100%"
                  highlight-current-row
                  @current-change="handleCurrentChange">
                  <el-table-column
                    label="用户"
                    width="120">
                    <template slot-scope="scope">
                      <el-checkbox v-model="scope.row.isActive"></el-checkbox>
                      <span
                        style="font-size: 12px">{{scope.row.name == '' ? scope.row.companyName : scope.row.name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="phone"
                    label="手机号"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="cagetory"
                    label="用户类型"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    label="实名状态">

                    <template slot-scope="scope">
                      <span style="font-size: 12px">{{scope.row.isReal == 1 ? '是' : '否'}} {{scope.row.isReal}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="card"
                    label="证件号码"
                    show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column
                    prop="email"
                    label="电子邮箱"
                    show-overflow-tooltip>
                  </el-table-column>
                </el-table>
              </div>
              <div class="t-btns" style="padding:10px 0 0 0">
                <el-button class="button" type="primary" @click="godown">下一步</el-button>
                <el-button class="button" @click="showChoseUser = false">返回</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pdfWarp" v-if="isShowDetail" v-show="!showLxr">
        <div class="htInfo">
          <span class="contractName">{{contractName}}</span>
          <div class="jumpBtn" v-show="!showAddWz">
            <div class="btn" @click="jumpSomePage('up')">上一处签署位置</div>
            <div class="btn" @click="jumpSomePage('last')">跳转末签署页</div>
            <div class="btn" @click="jumpSomePage('next')">下一处签署位置</div>
          </div>
          <div class="btns-t">
            <span @click="save(0)" class="save1" v-if="!isQs">保存草稿</span>
            <!--<span @click="addSign" v-if="showAddWz&&!isQs" class="save2">立即签署</span>-->
            <span @click="save(4)" class="save3" v-if="typ != 'qs'">立即发送</span>
            <span @click="submit" class="save3" v-if="isQs &&typ == 'qs'">提交</span>
            <span @click="detailBack" class="save4">返回</span>
          </div>
        </div>
        <div class="addBtnList">
          <div class="addBtnTop" v-if="showAddWz">
            <p class="t1">添加签署区</p>
            <p class="t2">拖动签章区至合适位置</p>
          </div>
          <div class="addBtn" v-for="(item,index) in choseList" :style="{background:type[index].color}"
               @click="addQM(type[index],item)"><i>+</i>
            新增{{type[index].name}}方签署区
          </div>
        </div>
        <div class="addBtnList hd" v-if="!showAddWz">
          <div class="addBtnTop">
            <p class="t3" @click="showWindow = true">选择签章 <span class="addWz"><i>+</i>新建签章</span></p>
          </div>
          <div class="signList">
            <div class="signItem" v-drags={item:item,moveFun:moveAddSign,moveEnd:activeqz} v-for="(item,index) in picList" @click="changeIsdefault(item.id)">
              <p class="name">{{item.name}}</p>
              <div class="signWarp" :class="{isDefault:item.isDefault==1}" :style="{'background-image':'url('+item.signUrl+')'}">
                <div class="bg"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="w2" ref="w2">
          <div id="dragWarp">
            <div class="nextPage pageBtn" @click="goPdfPage('next')" v-show="nowPage<allPage && allPage !=1">下一页<img
              src="../../assets/images/jtright.png" alt=""></div>
            <div class="beforePage pageBtn" @click="goPdfPage('before')" v-show="nowPage!=1 &&allPage !=1"><img
              src="../../assets/images/jtright.png" alt="">上一页
            </div>
            <pdfMain :pdfUrl="fileurl" :mainPage="nowPage" v-if="isReload && fileurl!=''"></pdfMain>
            <div class="drag-box" v-drag="{fun:moveSign,index:index,item:item,blvvv:testf}"
                 @click="activeqz(index)"
                 v-if="nowType === 10 || nowType === item.type"
                 v-for="(item,index) in canvasQzList[nowPage-1].qzList" :style="item.st">
              <img :src="item.sindImg" draggable="false" v-if="item.sindImg" class="singImg">
              <span class="remove" @click.stop="removeQz(nowPage-1,index)"
                    v-if="!isQs || (item.sindImg&&item.signId)"></span>
              <div v-if="!item.sindImg">
                <div class="bix" :style="{background:item.color}">
                  {{item.name}}方签署区
                </div>
                <div class="stg">
                  <span :style="{background:item.color}"></span>
                  <span :style="{background:item.color}"></span>
                  <span :style="{background:item.color}"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <pdfList v-if="isReload && fileurl!=''" :canvasQzList="canvasQzList" :nowType="nowType" :pdfUrl="fileurl"
                 :nowPage="nowPage"
                 v-on:changePage="getPage" v-on:allNum="allnum"></pdfList>
      </div>
    </div>
    <footerC v-if="!isShowDetail"></footerC>
    <div class="tc" v-show="hasNum || imgPay">
      <div class="innerBox">
        <p class="title">支付信息<span class="closeBtn" @click="goSomgPage('/documentList/5')"></span></p>
        <div class="content1" v-show="hasNum">
          {{payTxt}}
        </div>
        <div class="content2" v-show="imgPay">
          您当前账户剩余可签署文档份数为0,<br>
          本次签署支付费用 <i style="font-size: 14px;color: #D8662C">10.00</i>元<br>
          请扫描二维码进行支付。
          <img :src="payImg">
        </div>
        <div class="tcBottom">
          <div class="btn" @click="goSomgPage('/documentList/5')">完成</div>
        </div>
      </div>
    </div>
    <div class="newLxr" v-show="showWindow">
      <div class="lxrInner">
        <p class="title">新建签章<span class="closeBtn" @click="showWindow = false"></span></p>
        <div class="se1">
          <div class="name">签章名称:</div>
          <el-input v-model="qzmc" placeholder="输入签章名称"></el-input>
        </div>
        <div class="se1">
          <div class="name">是否为默认:</div>
          <el-checkbox v-model="checked">是否为默认</el-checkbox>
        </div>
        <div class="se1" style="padding-bottom: 20px;
          border-bottom: 1px solid rgb(237,237,237);">
          <div class="name" style="vertical-align: top">签章图片:</div>
          <el-upload
            class="avatar-uploader"
            action="http://www.absign.cn:8080/api/common/files/upload"
            :show-file-list="false"
            accept="image/*"
            :on-success="imgsucc">
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
        <div class="btns">
          <div class="btn" @click="saveQz">确定</div>
          <div class="btn cancel" @click="showWindow = false">取消</div>
        </div>
      </div>
    </div>
    <fireMsg ref="fireMsg" :successCall="getMsgBack" :htid="$route.params.id"></fireMsg>
  </div>
</template>
<script type="text/ecmascript-6">
  import Vue from 'vue'
  import {mapActions, mapGetters} from 'vuex'
  import homeNav from '../modules/nav.vue'
  import footerC from '../modules/bottom.vue'
  function parseDom(arg) {

    var objE = document.createElement("div");

    objE.innerHTML = arg;

    return objE.childNodes;

  };
  Vue.directive('drag',//自定义指令
    {
      bind: function (el, binding) {
        let oDrag = el;   //当前元素
        let self = this;  //上下文
        let oBox;
        setTimeout(function () {
          oBox = document.getElementById('dragWarp');
        }, 1);
        oDrag.onmousedown = function (e) {
          if (!binding.value.blvvv()) return
          //鼠标按下，计算当前元素距离可视区的距离
          let oEvent = e || event;
          let disX = oEvent.clientX - oDrag.offsetLeft;
          let disY = oEvent.clientY - oDrag.offsetTop;
          let obj;
          let bl = false
          document.onmousemove = function (ev) {
            bl = true
            let oEvents = ev || event;
            let left = oEvents.clientX - disX;
            let top = oEvents.clientY - disY;
            left <= 0 && (left = 0);
            top <= 0 && (top = 0);
            left >= (oBox.offsetWidth - oDrag.offsetWidth) && (left = oBox.offsetWidth - oDrag.offsetWidth);
            top >= (oBox.offsetHeight - oDrag.offsetHeight) && (top = oBox.offsetHeight - oDrag.offsetHeight);
            oDrag.style.left = left + 'px';
            oDrag.style.top = top + 'px';
            obj = {
              y: (top),
              x: (left),
              left: left + 'px',
              top: top + 'px'
            }
          };
          document.onmouseup = function () {
            if (bl) {
              let it = binding.value.item;
              obj['border-color'] = it.color;
              binding.value.fun(binding.value.index, obj);
            }
            document.onmousemove = null;
            document.onmouseup = null;
          };
        };
      }
    }
  );
  Vue.directive('drags',//自定义指令
    {
      /*
      * 伪代码：
      *       鼠标移动到新建按钮时，当鼠标滑动时获取鼠标的x,y的位置并且new一个dom 将获取到的x,y 计算后设置为其left 与top值
      *       当鼠标移动到签署位 区域后则像签章列表中生成一个item
      *       x,y 满足签章列表的坐标时吸附
      *       */
      /*
        item
      * moveFun:moveAddSign(index,x,y)
      * */
      bind: function (el, binding) {
        let oDrag = el;   //当前元素
        let self = this;  //上下文
        let oBox;
        setTimeout(function () {
          oBox = document;
        }, 1);
        oDrag.onmousedown = function (e) {
//          if (!binding.value.blvvv()) return
          //鼠标按下，计算当前元素距离可视区的距离
          let item = binding.value.item
          let li = parseDom(`<div class="drags-box" style="background-image: url(${item.signUrl})"></div>`),
            moveEv;
          document.getElementsByClassName('pdfWarp')[0].appendChild(li[0]);
          let warpInfo = document.getElementById('dragWarp').getBoundingClientRect();
          let end;
          let flag = 0;
          document.onmousemove = function (ev) {
            moveEv = ev
            let e = event || window.event,
              scrollX = document.documentElement.scrollLeft || document.body.scrollLeft,
              scrollY = document.documentElement.scrollTop || document.body.scrollTop,
              x = e.pageX || e.clientX + scrollX,
              y = e.pageY || e.clientY + scrollY,
              moves = document.getElementsByClassName('drags-box')[0];

            //              签章范围内
            let innerx = x - warpInfo.x, innery = y - warpInfo.y;
            end = binding.value.moveFun(item,innerx-65.2,innery-65.2);
            if(end){
              moves.style.left = (parseInt(end.st.x)+warpInfo.x) + 'px';
              moves.style.top = (parseInt(end.st.y)+warpInfo.y) + 'px';
            }else {
              moves.style.left = (x - 62.5) + 'px';
              moves.style.top = (y - 62.5) + 'px';
            }
            moves.style.opacity = 0.5;
          };
          document.onmouseup = function (ev) {
            if(end){
              binding.value.moveEnd(end.index)
              document.getElementsByClassName('drags-box')[0].remove()
              document.onmousemove = null;
              document.onmouseup = null;
              document.onclick = null
              console.log(1123)
            }
            document.onclick=function (ev) {
              flag = flag+1;
              console.log(flag)
              if(end){
                document.onmousemove = null;
                document.onmouseup = null;
                document.onclick = null
                binding.value.moveEnd(end.index)
                document.getElementsByClassName('drags-box')[0].remove()
              }else if(flag == 2){
                console.log(2,flag)
                document.getElementsByClassName('drags-box')[0].remove()
                document.onmousemove = null;
                document.onmouseup = null;
                document.onclick = null
              }

            }
//            document.getElementsByClassName('drags-box')[0].remove()
          };
        };
      }
    }
  );
  import pdfList from './pdfTest.vue'
  import pdfMain from './pdfMain.vue'
  import dra from './dragTest.vue'
  import fireMsg from './fireMsg.vue'

  export default {
    data() {
      return {
        loding: false,
        isQs: false,
        nowType: 10,
        fireName: '',
        checked: false,
        qzmc: '',
        imageUrl: '',
        showWindow: false,
        hasNum: false,
        imgPay: false,
        loading: false,
        payImg: '',
        isShowDetail: false,
        showLxr: true,
        nowPage: 1,
        showAddWz: true,
        canvasQzList: [
          {
            qzList: []
          }
        ],
        contractName: '',
        state1: '',
        filename: '注：本平台可上传80M以下文档',
        userType: '',
        payTxt: '',
        options: [{
          value: 0,
          label: '个人用户'
        }, {
          value: 1,
          label: '企业用户'
        }],
        pdfName: '',
        upLoding: false,
        showChoseUser: false,
        restaurants: [],
        isActive: false,
        nowChoseLxr: {},
        nowId: '',
        isReload: true,
        allPage: 0,
        fileurl: '',
        choseList: [
          {
            userType: 1,
            phone: '',
            email: '',
            companyName: '',
            card: ''
          },
          {
            userType: 1,
            phone: '',
            email: '',
            companyName: '',
            card: ''
          }
        ],
        type: [
          {
            type: 0,
            name: '甲',
            color: '#1656BD'
          },
          {
            type: 1,
            name: '乙',
            color: '#D7A73B'
          },
          {
            type: 2,
            name: '丙',
            color: '#7C0ACA'
          },
          {
            type: 3,
            name: '丁',
            color: '#000000'
          },
          {
            type: 4,
            name: '午',
            color: '#00B0FB'
          },
          {
            type: 5,
            name: '已',
            color: '#FB2663'
          }
        ],
        nowSignInfo: {},
        picList: [],
        contractId: 0,//合同id
        resultList: [],//获取到的签章列表
        clickQz: [],
        canDrag: true,
        timeLoading: true,
        timeLoading2: true,
        typ: '',
      }
    },
    created() {
      let _this = this;
      let token = this.$route.query.t;
      if(!token){
        this.$message({
          message: '用户信息有误，请重新的尝试',
          type: 'warning'
        });
        history.go(-1)
      }else {
        this.setCookie('userInfo',JSON.stringify({token:token}),1);
             this.getLxr();
             this.getData();
             this.typ = this.$route.params.type;
             _this.ajpost('/api/user/findUserInfo', {}, function (data) {
               if (data.code == 0) {
                 let userInfo = data.data;
                 console.log(userInfo)
                 _this.choseList[0].userType = userInfo.type,
                   _this.choseList[0].phone = userInfo.userPhone,
                   _this.choseList[0].email = userInfo.email,
                   _this.choseList[0].companyName = userInfo.companyName ||userInfo.userName,
                   _this.choseList[0].card = userInfo.idCard
               }
             }, function (err) {
             })
      }

    },
    methods: {
      ...mapActions([
        "aUserInfo"
      ]),
      submit() {
        this.getMsgBack()
      },
      getMsgBack(){
        this.loding = true;
        let ars = [];
        let _this =this;
        for (let i = 0; i < this.canvasQzList.length; i++) {
          let item = this.canvasQzList[i];
          if (item.qzList.length > 0) {
            for (let w = 0; w < item.qzList.length; w++) {
              let it = item.qzList[w];
              if (it.signId != 0) {
                ars.push({
                  "contractSignId": it.contractSignId,
                  "userSignId": it.signId
                })
                console.log(_this.nowType)
              } else if (!it.type != _this.nowType) {
                this.$message({
                  message: '您还有位置未签署,请先进行签署',
                  type: 'warning'
                });
                this.loding = false;
                return false;
              }
            }
          }
        }
        _this.ajpost('/api/contract/signContract', ars, function (data) {
          if (data.code == 0) {
            _this.loding = false;
            _this.$message({
              message: '提交成功',
              type: 'success'
            });
            _this.goSomgPage('/documentList/2')
          } else {
            _this.loding = false;
            _this.$message({
              message: data.msg,
              type: 'warning'
            });
          }
        })
      },
      goPdfPage(type) {
        let _this = this;
        if (this.timeLoading) {
          _this.timeLoading = false
          setTimeout(function () {
            _this.timeLoading = true
          }, 1000)
          if (type == 'before' && this.nowPage >= 2) {
            this.nowPage = this.nowPage - 1
          } else if (type == 'next' && this.nowPage < this.allPage) {
            this.nowPage = this.nowPage + 1
          }
        }
      },
      saveQz() {
        if (this.qzmc == '') {
          this.$message({
            message: '请填写签章名称！',
            type: 'warning'
          });
        } else if (this.fireName == '') {
          this.$message({
            message: '请上传签章图片！',
            type: 'warning'
          });
        } else {
          let _this = this,
            data = {
              "isDefault": (_this.checked) ? 1 : 0,
              "name": _this.qzmc,
              "url": _this.fireName.split('?')[0]
            };
          let url = '/api/user/addSign';
          _this.ajpost(url, data, function (data) {
            if (data.code != 0) {
              _this.$message({
                message: data.msg,
                type: 'warning'
              });
            } else {
              _this.$message({
                message: '操作成功',
                type: 'success'
              });
              _this.showWindow = false;
              _this.qzmc = "";
              _this.imageUrl = '';
              _this.fireName = '';
              _this.checked = false;
              _this.getLxr()
            }
          })
        }
      },
      imgsucc(data) {
        let _this = this;
        this.imageUrl = data.data.imageUrl;
        for (let key in data.data) {
          if (key != 'imageUrl') {
            _this.fireName = data.data[key]
          }
        }
      },
      closePayInfo() {
        this.hasNum = false;
        this.imgPay = false;
      },
      detailBack() {
        let t = this.typ;
        if (t == 'qs' || (t == 'edit' && this.canDrag)) {
          window.history.go(-1)
        } else if (t == 'add' && !this.showLxr && this.canDrag) {
          this.showLxr = true;
        } else if ((t == 'add' || t == 'edit') && !this.showAddWz && !this.canDrag) {
          this.showAddWz = true;
          this.canDrag = true;
          this.isQs = false;
          this.nowType = 10;
        }
      },
      getData() {
        let _this = this;
        if (this.$route.params.type == 'edit') {
          _this.ajpost('/api/contract/findDraftContract', {id: this.$route.params.id}, function (obj) {
            _this.contractId = obj.data.contractId;
            _this.contractName = obj.data.name;
            let fileName = obj.data.url.replace("http://absign.oss-cn-beijing.aliyuncs.com", "");
            _this.ajpost('/api/common/files/getFile', {url: fileName}, function (data) {
              _this.pdfName = fileName;
              _this.fileurl = data.data.data;
            })
            _this.resultList = obj.data.resultList;
            _this.isShowDetail = true;
            _this.showLxr = false;
          }, function (err) {
          })
        } else if (this.$route.params.type == 'qs') {
          _this.ajpost('/api/contract/findSignInfo', {id: this.$route.params.id}, function (obj) {
            _this.isShowDetail = true;
            _this.isQs = true;
            _this.showLxr = false;
            _this.showAddWz = false;
            _this.canDrag = false;
            _this.contractId = obj.data.contractId;
            _this.contractName = obj.data.name;
            _this.resultList = obj.data.signList;
            _this.nowType = obj.data.roleId;
            let fileName = obj.data.url.replace("http://absign.oss-cn-beijing.aliyuncs.com", "");
            _this.ajpost('/api/common/files/getFile', {url: fileName}, function (data) {
              _this.pdfName = fileName;
              _this.fileurl = data.data.data;
            })
          }, function (err) {
          })
        }
      },
      removeLxr(index) {
//        if(this.choseList)
        this.choseList.splice(index, 1)
      },
      next() {
        if (this.choseList.length < 1) {
          this.$message({
            message: '签署方必须大于或等于1位',
            type: 'warning'
          });
          return;
        }
        let _this = this;
        for (let i = 0; i < this.choseList.length; i++) {
          let item = this.choseList[i];
          if (item.companyName == '' || item.phone == '' || item.email == '' || item.card == '') {
            this.$message({
              message: '请仔细填写必填信息',
              type: 'warning'
            });
            return false;
          } else if (this.pdfName == '') {
            this.$message({
              message: '请上传文件',
              type: 'warning'
            });
            return false;
          } else if (this.contractName == '') {
            this.$message({
              message: '请填写文档名称',
              type: 'warning'
            });
            return false;
          } else if (item.card != '' && item.userType == 0 && (item.card.length != 18 && item.card.length != 15)) {
            this.$message({
              message: '请填写正确的身份证号',
              type: 'warning'
            });
            return false;
          }
        }
        this.showLxr = false;
        this.isShowDetail = true
        /*
          */
      },
      removeQz(i, o, item) {
        if (this.isQs) {
          this.canvasQzList[i].qzList[o].sindImg = ''
          this.canvasQzList[i].qzList[o].signId = 0
        } else {
          this.canvasQzList[i].qzList.splice(o, 1)
        }
      },
      goSomgPage(lin) {
        this.$router.push(lin)
      },
      save(n) {
        let _this = this, obj = {type: n}, url;
        this.loding = true;
        if (this.$route.params.type == 'add') {
          obj.contractName = _this.contractName;
          obj.contractUrl = _this.pdfName;
          let lxrList = [];
          this.choseList.forEach((item, index) => {
            let lxr = {
              cardNo: item.card,
              email: item.email,
              name: item.companyName,
              phone: item.phone,
              role: index,
              type: item.userType,
            };
            lxrList.push(lxr)
          });
          obj.list = lxrList;
          url = '/api/contract/addContract';
        } else if (_this.$route.params.type == 'edit') {
          obj.contractId = _this.$route.params.id
          url = '/api/contract/addDraftContract'
        }
        let qzList = [], signList = [];
        for (let i = 0; i < this.canvasQzList.length; i++) {
          for (let e = 0; e < this.canvasQzList[i].qzList.length; e++) {
            let userType = this.canvasQzList[i].qzList[e].type;
            signList[userType] = true;
          }
        }
        if (signList.length != this.choseList.length && n == 4) {
          this.$message({message: '每个签署方必须都至少有一个签章位置'});
          this.loding = false;
          return
        }
        this.canvasQzList.forEach((item, index) => {
          item.qzList.forEach((qz, qzi) => {
            let ob = {
              page: index,
              roleId: qz.type,
              x: qz.st.x,
              y: qz.st.y,
            };
            if (qz.signerId > 0) {
              ob.userId = qz.signerId
            }
            if (qz.signId > 0) {
              ob.signId = qz.signId
            }
            qzList.push(ob)
          })
        });
        obj.signList = qzList;
//        return;
        this.ajpost(url, obj, function (data) {
          if (data.code == 0) {
            if (n == 0) {
//              _this.loding = false;
              _this.$message({
                message: '保存成功',
                type: 'success'
              });
              _this.$router.push('/documentList/0')
            } else {
              let htid = data.data.data;
              /*if (_this.gUserInfo.userDetailResult.balance > 0) {
                payType = 1;
              } else {
                payType = 0;
              }*/
              _this.ajpost('/api/contract/sendContract', {contractId: htid}, function (datas) {
                if (datas.data.code == 0) {
//                  _this.loding = false;
                  _this.payTxt = datas.data.data;
                  _this.hasNum = true;
                } else {
                  _this.loding = false;
                  _this.ajpost('/api/order/preparePay?orderNo=' + datas.data.msg, {}, function (payData) {
                    _this.payImg = 'https://absign.oss-cn-beijing.aliyuncs.com/' + payData.data.data;
                    _this.imgPay = true;
                  });
                }
              });

            }
          }
        })
      },
      getLxr() {
        let _this = this;
        _this.ajpost('/api/user/findContactsList', {
          page_data: {
            "current_page": 0,
            "page_size": 999,
          },
          form_data: {
            type: 0
          }
        }, function (data) {
          let arw = [];
          data.data.list.forEach((item, index) => {
            item.isActive = false;
            arw.push(item)
          });
          _this.restaurants = arw;
        })
        _this.ajpost('/api/user/findSignList', {}, function (data) {
          let list = data.data||[];
          _this.picList = list;
          list.forEach((item, index) => {
            if (item.isDefault == 1) {
              _this.nowSignInfo = item;
            }
          })
        },function (err) {
          console.log(err)
        })
      },
      changeIsdefault(id) {
        let _this = this;
        this.picList.forEach((item, index) => {
          if (item.id == id) {
            item.isDefault = 1;
            _this.nowSignInfo = item;
          } else {
            item.isDefault = 0
          }
        })
      },
      addLxr() {
        if (this.choseList.length < 6) {
          this.choseList.push({
            userType: 1,
            phone: '',
            email: '',
            companyName: '',
            card: ''
          })
        }
      },
      godown() {
        let obj = {};
        let _this = this;
        this.restaurants.forEach((item, index) => {
          if (item.id == _this.nowChoseLxr.id) {
            obj = JSON.parse(JSON.stringify(item));
            obj.userType = (obj.cagetory == '个人') ? 0 : 1
            obj.companyName = (obj.cagetory == '个人') ? obj.name.split(',')[0] : obj.companyName
            _this.choseList[_this.nowId] = obj;
            _this.showChoseUser = false;
            _this.zk();
          }
        });
      },
      zk() {
        this.restaurants.forEach((item, index) => {
          this.restaurants[index].isActive = false;
        });
      },
      removeUp() {
        this.pdfName = ''
      },
      handleCurrentChange(d) {
        let _this = this;
        if (d.isReal != 1) {
          this.$message({
            message: '您选择的用户非本系统实名认证用户，对方成为本系统用户前无法签署本文档',
            type: 'warning'
          })
        }
        _this.restaurants.forEach((item, index) => {
          if (item.id != d.id) {
            _this.restaurants[index].isActive = false
          } else {
            _this.nowChoseLxr = d;
            _this.restaurants[index].isActive = true
          }
        });
      },
      beforeAvatarUpload(d) {
        this.upLoding = true;
        this.filename = d.name.replace(".pdf", "");
        this.contractName = d.name.replace(".pdf", "");
        this.isReload = false;
      },
      handleAvatarSuccess(dta) {
        let _this = this;
        for (var keys in dta.data) {
          _this.ajpost('/api/common/files/getFile', {url: dta.data[keys]}, function (data) {
            _this.pdfName = dta.data[keys];
            _this.fileurl = data.data.data;
            _this.upLoding = false;
            _this.isReload = true;
          })
        }
      },
      querySearch(queryString, cb) {
        var restaurants = this.restaurants;
        let reList = [];
        restaurants.forEach(function (data) {
          for (var key in data) {
            let v = data[key] + '';
            if (v.indexOf(queryString) === 0) {
              data.value = data.name;
              reList.push(data);
              break;
            }
          }
        });
        cb(reList);
      },
      handleSelect(items) {
        this.restaurants.forEach((item, index) => {
          if (item.value == items.value) {
            document.getElementsByClassName('el-table__body-wrapper')[0].scrollTop = document.getElementsByClassName('el-table__body-wrapper')[0].children[0].children[1].children[index].offsetTop;
            document.getElementsByClassName('el-table__body-wrapper')[0].children[0].children[1].children[index].style.backgroundColor = "pink"
            setTimeout(function () {
              document.getElementsByClassName('el-table__body-wrapper')[0].children[0].children[1].children[index].style.backgroundColor = "#fff"
            }, 3000)
          }
        })
      },
      getPage(data) {
        if (this.nowPage != data) {
          this.nowPage = data
        }
      },
      addQM(it, user) {
        let left = (document.querySelector('#dragWarp').clientWidth / 2) - 62.5
          , top = ((document.querySelector('.w2').clientHeight / 2) + document.querySelector('.w2').scrollTop) - 62.5
          , obj =
          {
            st: {left: left + 'px', top: top + 'px', 'border-color': it.color, x: left, y: top},
            name: it.name,
            type: it.type,
            color: it.color,
            signId: 0,
            sindImg: ''
          };
        if (user.signerId) {
          obj.signerId = user.signerId
        }
        this.canvasQzList[this.nowPage - 1].qzList.push(obj)
      },
      moveSign(index, obj) {
        this.canvasQzList[this.nowPage - 1].qzList[index].st = obj;
      },
      allnum(data) {
        this.allPage = data;
        let _this = this;
//        this.canvasQzList = [];
        let pageAll = [];
        for (let i = 0; i < data; i++) {
          pageAll.push({
            qzList: []
          });
        }
        if (this.resultList.length > 0 && !this.isQs) {
          let userList = [];
          let ars = JSON.parse(JSON.stringify(this.resultList));
          ars.forEach((item, index) => {
            let obj = {
              signerId: item.signerId
            };
            userList.push(obj);
            item.signList.forEach((it, ind) => {
              pageAll[it.page].qzList.push(
                {
                  st: {
                    x: it.x,
                    y: it.y,
                    left: it.x + 'px',
                    top: it.y + 'px',
                    'border-color': _this.type[item.roleId].color
                  },
                  name: _this.type[item.roleId].name,
                  type: item.roleId,
                  signerId: item.signerId,
                  signId: it.signId,
                  sindImg: it.signUrl,
                  color: _this.type[item.roleId].color
                }
              )
            })
          });
          _this.choseList = userList;
        } else if (this.resultList.length > 0 && _this.isQs) {
          let userList = [];
          let ars = JSON.parse(JSON.stringify(this.resultList));
          ars.forEach((item, index) => {
            pageAll[item.page].qzList.push(
              {
                st: {
                  x: item.x,
                  y: item.y,
                  left: item.x + 'px',
                  top: item.y + 'px',
                  'border-color': _this.type[_this.nowType].color
                },
                name: _this.type[_this.nowType].name,
                type: _this.nowType,
                signerId: '',
                signId: 0,
                contractSignId: item.contractSignId,
                sindImg: '',
                color: _this.type[_this.nowType].color
              }
            )
          });
          _this.choseList = userList;
        }
        this.canvasQzList = pageAll
      },
      addSign() {
        this.showAddWz = false;
        this.canDrag = false;
        this.isQs = true;
        if (this.$route.params.type == 'edit' || this.$route.params.type == 'add') {
          this.nowType = 0;
        }
      },
      activeqz(index) {
        let nowPage = this.nowPage-1
        if (!this.showAddWz && !this.canDrag) {
//
          this.clickQz = [nowPage, index];
          this.canvasQzList[nowPage].qzList[index].signId = this.nowSignInfo.id;
          this.canvasQzList[nowPage].qzList[index].sindImg = this.nowSignInfo.signUrl;
        }
      },
      jumpSomePage(type) {
        let _this = this;
        if (this.timeLoading2) {
          _this.timeLoading2 = false
          setTimeout(function () {
            _this.timeLoading2 = true
          }, 1000)
          if (type == 'up') {
            for (let i = this.nowPage - 2; i >= 0; i--) {
              let thisItem = this.canvasQzList[i];
              if (thisItem.qzList.length > 0) {
                for (let e = 0; e < thisItem.qzList.length; e++) {
                  if (thisItem.qzList[e].type == this.nowType) {
                    this.nowPage = i + 1;
                    return;
                  }
                }
              }
            }
            for (let i = this.allPage - 1; i >= 0; i--) {
              let thisItem = this.canvasQzList[i];
              if (thisItem.qzList.length > 0) {
                for (let e = 0; e < thisItem.qzList.length; e++) {
                  if (thisItem.qzList[e].type == this.nowType) {
                    this.nowPage = i + 1;
                    return;
                  }
                }
              }
            }
          } else if (type == 'last') {
            for (let i = this.allPage - 1; i >= 0; i--) {
              let thisItem = this.canvasQzList[i];
              if (thisItem.qzList.length > 0) {
                for (let e = 0; e < thisItem.qzList.length; e++) {
                  if (thisItem.qzList[e].type == this.nowType) {
                    this.nowPage = i + 1;
                    return;
                  }
                }
              }
            }
          } else if (type == 'next') {
            for (let i = this.nowPage; i < this.allPage; i++) {
              let thisItem = this.canvasQzList[i];
              if (thisItem.qzList.length > 0) {
                for (let e = 0; e < thisItem.qzList.length; e++) {
                  if (thisItem.qzList[e].type == this.nowType) {
                    this.nowPage = i + 1;
                    return;
                  }
                }
              }
            }
            for (let i = 0; i < this.allPage; i++) {
              let thisItem = this.canvasQzList[i];
              if (thisItem.qzList.length > 0) {
                for (let e = 0; e < thisItem.qzList.length; e++) {
                  if (thisItem.qzList[e].type == this.nowType) {
                    this.nowPage = i + 1;
                    return;
                  }
                }
              }
            }
          }
        }

      },
      testf() {
        return this.canDrag
      },
      moveAddSign(item,x,y) {
        this.nowSignInfo = item;
        let qzlist = this.canvasQzList[this.nowPage - 1].qzList;
        let findEnd = qzlist.find(function(element,index) {
          let item = element.st,
            ix = Math.floor(item.x-x),
            iy = Math.floor(item.y-y);
          element.index = index;
          return Math.abs(ix)<10 && Math.abs(iy)<10;
        });
        return findEnd;
      }
    },
    components: {
      pdfList,
      pdfMain,
      homeNav,
      footerC,
      fireMsg
    },
    computed: {
      ...mapGetters([
        "gUserInfo"
      ])
    }
  }
</script>
<style>
  @import "../../assets/less/fireList.css";
  @import "../../assets/less/fire.css";
</style>
<style type="text/less" lang="less" rel="stylesheet/less" scoped="scoped">
  .pdfWarp {
    position: relative;
    background: rgba(0, 0, 0, 0.3);
    .htInfo {
      background: #ffffff;
      line-height: 70px;
      height: 70px;
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      box-shadow: 2px -1px 23px rgba(0, 0, 0, .2);
      z-index: 10;
      .jumpBtn {
        width: 30%;
        position: absolute;
        left: 50%;
        display: flex;
        justify-content: space-around;
        top: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        .btn {
          width: 150px;
          line-height: 42px;
          height: 40px;
          color: #ffffff;
          background: #2764C2;
          display: inline-block;
          box-shadow: 2px -1px 23px rgba(0, 0, 0, 0.1);
          cursor: pointer;
          font-size: 12px;
          text-align: center;
          &:nth-child(2) {
            background: #ffffff;
            color: #000;
          }
          &:last-child {
            float: right;
          }
        }
      }
      .contractName {
        font-size: 20px;
        padding-left: 45px;
        font-weight: 600;
        width: 450px;
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-all;
      }
      .btns-t {
        display: flex;
        height: 70px;
        align-items: center;
        float: right;
        margin-right: 40px;
        span {
          font-size: 12px;
          display: inline-block;
          width: 100px;
          height: 30px;
          line-height: 31px;
          color: #ffffff;
          margin-left: 30px;
          background: rgb(22, 86, 189);
          text-align: center;
          border: 1px solid rgb(22, 86, 189);
          cursor: pointer;
          &.save4 {
            background: #fff;
            border-color: #BCBCBC;
            color: #000;
          }
          &.save3 {
            background: #F39841;
            border-color: #F39841;
          }
        }
      }
    }
    .addBtnList {
      width: 280px;
      position: fixed;
      top:0;
      bottom: 0;
      background: #FDFEFE;
      left: 0;
      z-index: 1;
      box-shadow: 5px 0px 15px rgba(0, 0, 0, 0.1);
      &.hd {
        overflow-y: scroll;
      }
      .addBtnTop {
        height: 70px;
        text-align: center;
        font-size: 10px;
        background: #ffffff;
        border-bottom: 1px solid #EFEFEF;
        box-sizing: border-box;
        .t1 {
          font-size: 14px;
          padding: 20px 0 10px 0;
          font-weight: 600;
        }
        .t3 {
          font-size: 14px;
          line-height: 70px;
          text-align: left;
          padding-left: 40px;
          .addWz {
            width: 100px;
            line-height: 25px;
            border: 1px solid #1656BD;
            display: inline-block;
            vertical-align: middle;
            color: #1656BD;
            margin-left: 50px;
            font-size: 12px;
            cursor: pointer;
            i {
              font-size: 20px;
              color: #1656BD;
              margin: 0 10px;
              vertical-align: -1px;
            }
          }
        }
        .t2 {
          font-size: 10px;
          color: rgba(0, 0, 0, 0.4);
        }
      }
      .signList {
        .signItem {
          width: 195px;
          margin: 30px auto;
          .name {
            font-size: 10px;
            margin-bottom: 10px;
          }
          .signWarp {
            border: 1px solid #EEEEEE;
            width: 195px;
            height: 195px;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center center;
            &.isDefault {
              border-color: #EEEEEE;
              position: relative;
              .bg {
                background: url("../../assets/images/bg_choose_pre.png");
                background-size: 100% 100%;
                width: 100%;
                height: 100%;
                position: absolute;
                z-index: 1;
                left: 0;
                top: 0;
              }
            }
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }

      .addBtn {
        width: 185px;
        line-height: 45px;
        height: 45px;
        color: #ffffff;
        background: #000000;
        font-size: 12px;
        text-align: center;
        margin: 0 auto;
        margin-top: 30px;
        cursor: pointer;
        i {
          font-size: 17px;
          vertical-align: 0;
          margin-right: 10px;
        }
      }
    }
    .w2 {
      position: fixed;
      left: 280px;
      right: 280px;
      top: 0;
      bottom: 0;
      background: #ECF0F4;
      overflow: auto;
      padding-bottom: 50px;
      padding-top: 80px;
      #dragWarp {
        margin: 0 auto;
        width: auto;
        display: table;
        position: relative;
        .pageBtn {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 80px;
          line-height: 43px;
          height: 40px;
          overflow: hidden;
          font-size: 12px;
          background: rgba(0, 0, 0, 0.4);
          color: #ffffff;
          cursor: pointer;
          z-index: 2;
          img {
            width: 11px;
            height: 12px;
            vertical-align: -1px;
          }
          &.beforePage {
            left: 0;
            padding-right: 15px;
            text-align: right;
            img {
              margin-right: 10px;
              transform: rotate(180deg);
            }
          }
          &.nextPage {
            padding-left: 15px;
            right: 0;
            text-align: left;
            img {
              margin-left: 10px;
            }
          }
        }
      }
    }
    .pdfInnerFooter {
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      z-index: 1;
    }
  }

  .fireFooter {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
  }

  .innerS {
    width: 100%;
  }

  .drag-box {
    width: 125px;
    height: 125px;
    position: absolute;
    border: 2px dashed #cccccc;
    .singImg {
      width: 100%;
      height: 100%;
    }
    .remove {
      position: absolute;
      width: 20px;
      height: 20px;
      right: -12px;
      top: -12px;
      background: url("../../assets/images/icon_deletet.png");
      background-size: 100% 100%;
      border-radius: 50%;
    }
    .bix {
      width: 100%;
      height: 100%;
      background: rgb(0, 0, 0);
      opacity: .3;
      position: relative;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      line-height: 125px;
    }
    .stg {
      width: 25px;
      height: 25px;
      position: absolute;
      right: 13px;
      bottom: 13px;
      span {
        width: 100%;
        height: 3px;
        background: #cccccc;
        display: block;
        position: absolute;
        left: 0;
        opacity: .6;
        &:nth-child(1) {
          top: 0;
        }
        &:nth-child(2) {
          top: 50%;
          transform: translateY(-50%);
        }
        &:nth-child(3) {
          bottom: 0;
        }
      }
    }
  }
</style>

<style lang="less">
  .drags-box {
    opacity: 0;
    width: 125px;
    height: 125px;
    position: fixed !important;
    background-size:100% 100%;
    background-position: 100% 100%;
    z-index: 1111;
  }

</style>



// WEBPACK FOOTER //
// src/components/fire/ffire.vue